module.exports = __webpack_public_path__ + "static/media/stats.4cbe6c92.svg";